import React from 'react';
import CardBody from './CardBody';
import { warnOnce } from './utils';
export default function CardBlock(props) {
  warnOnce('The "CardBlock" component has been deprecated.\nPlease use component "CardBody".');
  return React.createElement(CardBody, props);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactstrap/es/CardBlock.js
// module id = 254
// module chunks = 0